// src/components/ui/Textarea.js
import React from "react";
import clsx from "clsx";

export function Textarea({ className, ...props }) {
  return (
    <textarea
      spellCheck={props.spellCheck !== undefined ? props.spellCheck : true}
      lang={props.lang || "en"}
      className={clsx(
        "w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500",
        className
      )}
      {...props}
    />
  );
}
